import SecondaryNavigation from "@/components/SecondaryNavigation";
import { SecondaryNavigation as SecondaryNavigationType } from "@/components/SecondaryNavigation/types";
import {
  BuilderBlock,
  Blocks,
  RegisteredComponents,
  BuilderContextInterface,
  isEditing,
} from "@builder.io/sdk-react";
import { FC } from "react";

type SecondaryNavigationBlockProps = {
  alwaysVisibleBlocks: BuilderBlock[];
  visibleWhenStickyBlocks: BuilderBlock[];
  builderBlock: BuilderBlock;
  builderComponents: RegisteredComponents;
  builderLinkComponent: unknown;
  builderContext: BuilderContextInterface;
} & SecondaryNavigationType;

export const SecondaryNavigationBlock: FC<SecondaryNavigationBlockProps> = ({
  alwaysVisibleBlocks,
  visibleWhenStickyBlocks,
  builderBlock,
  builderComponents,
  builderLinkComponent,
  builderContext,
  newSecondaryNavigation,
  ...secondaryNavigationProps
}) => (
  <SecondaryNavigation
    {...secondaryNavigationProps}
    newSecondaryNavigation={newSecondaryNavigation}
    isStickyTop={isEditing()}
    rightColumn={{
      alwaysVisible: newSecondaryNavigation ? null : (
        <Blocks
          parent={builderBlock?.id}
          blocks={alwaysVisibleBlocks}
          path="alwaysVisibleBlocks"
          registeredComponents={builderComponents}
          linkComponent={builderLinkComponent}
          context={builderContext}
        />
      ),
      visibleWhenSticky: (
        <Blocks
          parent={builderBlock?.id}
          blocks={visibleWhenStickyBlocks}
          path="visibleWhenStickyBlocks"
          registeredComponents={builderComponents}
          linkComponent={builderLinkComponent}
          context={builderContext}
        />
      ),
    }}
  />
);
